import { render, staticRenderFns } from "./Serivce3.vue?vue&type=template&id=760552f2&"
import script from "./Serivce3.vue?vue&type=script&lang=js&"
export * from "./Serivce3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports